import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

// Full-width cinematic image band with slow parallax scale and navy overlay.
export default function ParallaxImage({ src, alt = "", className = "", overlay = "bg-navy-900/55", children, height = "h-[80vh]" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <div ref={ref} className={`relative overflow-hidden ${height} ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ scale, y }}
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className={`absolute inset-0 ${overlay}`} />
      {children && <div className="relative z-10 h-full">{children}</div>}
    </div>
  );
}
